import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Text } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
/** Represents a component for whenever there are no sms phone numbers. */
export const SmsEmpty = () => {
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", alignItems: "center", gap: sizes.spacer[200], margin: "150px 0 0 0" }, { children: [_jsx(Text.Heading, { children: "Give your customers text message support" }), _jsx(Box, Object.assign({ width: "350px" }, { children: _jsx(Text.Paragraph, Object.assign({ align: "center" }, { children: "Interested? Contact our Customer Success team for more details." })) }))] })));
};
